export default __webpack_public_path__ + "static/cat-and-human-illustration-8be17bf0b56325a8608dc3f88b0a8dab.svg";